import { gql } from '@apollo/client'
import productsFieldsQuery from '../../commons/fields/products'

/**
 * Gets the string for `buyAgainQuery` query.
 * Returns the list of products the current user has previously bought
 * and is likely to reorder. Server-side handles dedup, ordering, and
 * any SKU exclusion based on current cart contents.
 * @internal
 */

const buyAgainQuery = gql`
  query BuyAgain(
    $storefrontName: String!,
    $sessionUid: ID!,
    $limit: Int
  ) {
    buyAgain(
      storefrontName: $storefrontName,
      sessionUid: $sessionUid,
      limit: $limit
    ) {
      items {
        ${productsFieldsQuery}
      }
    }
  }
`

export default buyAgainQuery
